/**
 * External dependencies
 */
import React from "react";
import LoggedInTopbar from "layout/topbar/logged-in";
import { first } from "lodash";
import page from "page";

/**
 * Internal dependencies
 */

import Dashboard from "./main";
import { getLayout, getAllLayouts } from "state/dashboard-layouts/selectors";
import { switchLayout } from "state/dashboard/actions";
import { getLayoutId } from "state/dashboard/selectors";
import { getPreference } from "state/preferences/selectors";

export const dashboard = (context, next) => {
  const dashboardId = context.params.dashboardId;
  const state = context.store.getState();
  const activeDashboardId = getLayoutId(state);
  const dashboard = getLayout(state, dashboardId);
  const defaultDashboardId = getPreference(state, "defaultDashboard");

  // if there is a dashboard passed and it is valid
  // then continue
  if (dashboard) {
    context.store.dispatch(switchLayout(dashboardId));
    context.primary = <Dashboard />;
    return next();
  }

  if (activeDashboardId && getLayout(state, activeDashboardId)) {
    return page.redirect(`/decks/${activeDashboardId}`);
  }

  if (defaultDashboardId && getLayout(state, defaultDashboardId)) {
    return page.redirect(`/decks/${defaultDashboardId}`);
  }

  // if there is no dashboard id, set one and redirect
  if (!dashboardId) {
    let layouts = getAllLayouts(state);
    let layout = first(layouts);
    if (layout) {
      return page.redirect(`/decks/${layout.id}`);
    }
  }

  context.primary = <Dashboard />;
  next();
};

export const navigation = (context, next) => {
  context.topbar = <LoggedInTopbar path={context.path} />;
  next();
};
